import { render, staticRenderFns } from "./Watch.vue?vue&type=template&id=3c808d6a&scoped=true"
import script from "./Watch.vue?vue&type=script&lang=js"
export * from "./Watch.vue?vue&type=script&lang=js"
import style0 from "./Watch.vue?vue&type=style&index=0&id=3c808d6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c808d6a",
  null
  
)

export default component.exports